import * as React from 'react';
import { createViewConfig, dynamic, media } from '@sail/engine';
import { css, tokens } from '@sail/ui';
import { helmTokens } from '../../theme';
import { copyTokens } from './tokens';
export const TitleConfig = createViewConfig({
    name: 'Title',
    props: {},
    flattens: true,
    defaults: {
        accented: false,
        anchored: false,
        variant: 'section'
    }
});
const getDefaultTag = (variant)=>{
    switch(variant){
        case 'hero':
            return 'h1';
        case 'section':
            return 'h2';
        case 'subsection':
        case 'detail':
        case 'footer':
        case 'stat':
            return 'h3';
        default:
            return 'h2';
    }
};
export const Title = TitleConfig.createView(({ tag, variant, anchored, ...props })=>{
    const TitleTag = tag ? tag : getDefaultTag(variant);
    return /*#__PURE__*/ React.createElement(TitleTag, props);
}, {
    css: {
        position: 'relative',
        color: 'emphasized'
    },
    uses: [
        dynamic(({ variant, anchored })=>{
            if (anchored || variant === 'detail' || variant === 'stat') {
                return [
                    css({
                        '::before': {
                            display: 'block',
                            content: '""',
                            width: '1px',
                            height: `1em`,
                            position: 'absolute',
                            left: `calc(-1 * ${copyTokens.columnPaddingLeft})`,
                            top: `calc(.5px + (1lh - 1em) / 2)`,
                            backgroundColor: `${helmTokens.color.accentColor}`
                        }
                    })
                ];
            }
        })
    ],
    variants: {
        accented: {
            true: css({
                color: `${helmTokens.color.accentColor}`
            })
        },
        variant: {
            hero: [
                css({
                    font: 'heading.xlarge',
                    letterSpacing: `${helmTokens.letterSpacing.xxsmall}`,
                    [media.up(tokens.viewport.xlarge)]: {
                        font: 'display.xlarge'
                    }
                })
            ],
            section: [
                css({
                    font: 'heading.large',
                    [media.up(tokens.viewport.xlarge)]: {
                        font: 'display.large'
                    },
                    letterSpacing: `${helmTokens.letterSpacing.small}`,
                    [media.up(tokens.viewport.large)]: {
                        letterSpacing: `${helmTokens.letterSpacing.xsmall}`
                    }
                })
            ],
            subsection: [
                css({
                    font: 'heading.medium',
                    letterSpacing: `${helmTokens.letterSpacing.medium}`,
                    [media.up(tokens.viewport.small)]: {
                        font: 'display.medium',
                        letterSpacing: 0
                    }
                })
            ],
            footer: [
                css({
                    font: 'heading.medium',
                    letterSpacing: `${helmTokens.letterSpacing.medium}`
                })
            ],
            stat: [
                css({
                    font: 'heading.medium',
                    letterSpacing: `${helmTokens.letterSpacing.medium}`
                })
            ],
            detail: [
                css({
                    font: 'heading.small',
                    letterSpacing: `${helmTokens.letterSpacing.large}`
                })
            ]
        }
    },
    forward: {
        variant: true
    }
});

//# sourceMappingURL=Title.js.map